import VoyageConstraintsData from "../data";

export default function voyageConstraintsDataFromJson(json) {
    return new VoyageConstraintsData(
        json.id,
        json.max_turning_angle,
        json.max_wind_service_speed,
        json.max_wind_cruise_speed,
        json.max_wave_service_height,
        json.max_wave_cruise_height,
    );
}